module.exports = __webpack_public_path__ + "static/media/1-1-Z-ducha-sv-pocala.819dea8e.jpg";